module.exports = __webpack_public_path__ + "static/media/raconteur-logo-1024.6f0864ac.png";